




















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class StatusIcon extends Vue {
  @Prop() status!: boolean | null
  @Prop({ default: 'نامشخص' }) labelWhenNull!: string | null

}
